import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteProjectBOUsersRPC } from "./deleteProjectBoUsersRPC";

export class DeleteProjectBOUsersRPCClientImpl extends DeleteProjectBOUsersRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteProjectBOUsersRPC.Request): Promise<LeoRPCResult<DeleteProjectBOUsersRPC.Response, DeleteProjectBOUsersRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/DeleteProjectBOUsers",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteProjectBOUsersRPC.ResponseDTO,
      DeleteProjectBOUsersRPC.Errors.ErrorsDTO,
      DeleteProjectBOUsersRPC.Response,
      DeleteProjectBOUsersRPC.Errors.Errors
    >(
      response,
      "bo-user-management/DeleteProjectBOUsers",
      DeleteProjectBOUsersRPC.Response.fromDTO,
      DeleteProjectBOUsersRPC.Errors.fromDTO
    );
  }
}
